import React from "react";
import { Outlet, RouterProvider } from "react-router-dom";
import MainLayout from "./components/layout/MainLayout/MainLayout";
import { AppProvider } from "./context/AppContext";
import { router } from "./routes/routes";

const App: React.FC = () => {
  return (
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
  );
};

export default App;
